import { useEffect, useRef, useState } from "react";
import { Inbox, Building2, LifeBuoy, ChevronDown, User } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { publicAsset } from "../../features/tenantPath";
import { SharedSidebar } from "../../components";
import VzhladTlacidlo from "../../components/VzhladPrepinac/VzhladTlacidlo";
import SupportTicketsSection from "../AdminPage/sections/SupportTicketsSection";
import PlatformLogin from "./sections/PlatformLogin";
import RequestsSection from "./sections/RequestsSection";
import CompaniesSection from "./sections/CompaniesSection";
// hlavicka, bocny panel, tabulky, formulare a modaly su tie iste ako
// v admin paneli prevadzky -- spravu odlisuje len farba (PlatformTheme.scss)
import "../../components/Header/Header.scss";
import "../AdminPage/AdminPage.scss";
import "./PlatformPage.scss";
import "./PlatformTheme.scss";

/**
 * Platformova sprava na rozvozy.sk/sprava -- SUPERADMIN ako dodavatel systemu.
 * Vlastny login (POST /api/platform/login), token v samostatnom kluci
 * tenantStorage ("platform"), takze sa nebije s tokenmi prevadzok.
 */
const SEKCIE = [
  { key: "requests", label: "Žiadosti", icon: Inbox },
  { key: "companies", label: "Prevádzky", icon: Building2 },
  { key: "tickets", label: "Hlásenia chýb", icon: LifeBuoy },
];

// Trieda na <body>, nie na obale stranky -- dropdowny Selectu a modaly sa
// renderuju cez portal mimo stromu PlatformPage a tiez maju byt v tme spravy.
const THEME_CLASS = "theme-platform";

function PlatformPage() {
  const { isLoggedIn, isPlatform, authLoading, userName, userSurname, userEmail, logout } = useAuth();
  const [sekcia, setSekcia] = useState("requests");
  const [menuOtvorene, setMenuOtvorene] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    document.body.classList.add(THEME_CLASS);
    return () => document.body.classList.remove(THEME_CLASS);
  }, []);

  useEffect(() => {
    if (!menuOtvorene) return undefined;
    const zavri = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOtvorene(false);
    };
    document.addEventListener("mousedown", zavri);
    return () => document.removeEventListener("mousedown", zavri);
  }, [menuOtvorene]);

  if (authLoading) return null;
  if (!isLoggedIn || !isPlatform) return <PlatformLogin />;

  const meno = [userName, userSurname].filter(Boolean).join(" ") || userEmail;

  return (
    <div className="platform">
      <header className="header platform__header">
        <div className="header__container">
          <span className="header__logo platform__logo">
            <img src={publicAsset("rozvozy_icon.png")} height="35" alt="Rozvozy" />
            <span className="platform__logo-label">Správa systému</span>
          </span>

          <div className="platform__akcie">
            <div className="header__user-menu" ref={menuRef}>
              <button
                type="button"
                className="header__user-trigger"
                onClick={() => setMenuOtvorene((o) => !o)}
                aria-expanded={menuOtvorene}
                aria-haspopup="true"
              >
                <User size={14} className="header__user-icon" />
                <span className="header__user-name">{meno}</span>
                <ChevronDown
                  size={14}
                  className={`header__user-chevron${menuOtvorene ? " header__user-chevron--open" : ""}`}
                />
              </button>
              {menuOtvorene && (
                <div className="header__user-dropdown">
                  <button
                    type="button"
                    className="header__dropdown-item header__dropdown-item--danger"
                    onClick={() => {
                      setMenuOtvorene(false);
                      logout();
                    }}
                  >
                    Odhlásiť sa
                  </button>
                </div>
              )}
            </div>
            <VzhladTlacidlo />
          </div>
        </div>
      </header>

      <div className="admin">
        <SharedSidebar title="SPRÁVA SYSTÉMU" items={SEKCIE} activeKey={sekcia} onSelect={setSekcia} />
        <main className="admin__content">
          {sekcia === "requests" && <RequestsSection />}
          {sekcia === "companies" && <CompaniesSection />}
          {sekcia === "tickets" && <SupportTicketsSection platform />}
        </main>
      </div>
    </div>
  );
}

export default PlatformPage;
